import { BrandedAuth } from '@components/branded-auth';

interface RouteGuardProps {
  children: React.ReactNode;
}
function RouteGuard({ children }: RouteGuardProps) {
  return <BrandedAuth children={children} />;
}

export default RouteGuard;
